import axios from "axios";

export const fetchCmsMetaData = async (pageUrl) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE}/getCmsContent`,
      { post_url: pageUrl }
    );

    // return only useful CMS data
    return res?.data?.data || null;
  } catch (error) {
    // ❗ If CMS not found (404) → silently ignore
    if (error?.response?.status === 404) {
      console.warn(`CMS meta not found for page: ${pageUrl}`);
      return null; // safe fallback
    }

    // ❗ For other errors → log but DO NOT crash UI
    console.error(`Error fetching CMS meta for ${pageUrl}:`, error);
    return null;
  }
};
